import { presenterHub } from '@RestApi/types'

export const retrieveSignedInUserPermissions = (hub: presenterHub) => {
  return {
    canOpenPopup: hub.user_context.perms.team.open_user_popup,
    canSeeMemberIdsAndEmails: hub.user_context.perms.team.view.member_ids,
  }
}
